import gql from 'graphql-tag'

const query = gql`query ordering ($cart: CartInput!) {
  orderCart (cart: $cart) {
    targetTariff {
      ...cartTariff
    }
    targetTariffoptions {
      bookableTariffoptions {
        ...cartTariffoption
      }
    }
    targetPromotion {
      ...cartPromo
    }
    campaignToken
    promoCode
    prices {
      yearlyBasicFee
      yearlyBasicFeeFormatted
      totalMonthlyFee
      totalMonthlyFeeFormatted
      totalSinglePaymentFee
      totalSinglePaymentFeeFormatted
    }
  }
}
fragment cartTariff on TargetTariff {
  baseTariffId
  basicFee
  name
  tariffId
  volumes {
    amount
    formattedUnit
    type
    unit
  }
  bandwidth {
    down
    formattedUnit
  }
}
fragment cartTariffoption on BookableTariffoption {
  price
  name
  tariffoptionId
  volumes {
    amount
    formattedUnit
    type
    unit
  }
  bandwidth {
    down
    formattedUnit
  }
}
fragment cartPromo on BookablePromotion {
  promotionId
  name
  incentives {
    id
    type
    ...on ServiceIncentive {
      service
    }
    ...on CreditIncentive {
      discount
      targetFee
    }
    ...on OtherIncentive {
      kind
    }
    ...on VolumeIncentive {
      amount
      unit
    }
  }
  notBookableWith
  requiredParameters
  duration {
    amount
    unit
    formattedUnit
    specificEndDate
    type
  }
}`

export default query
